import { SmartfireComponent, smartProps } from "@smartfire/gutenberg-react";
import "./style.scss";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import React from "react";
import { Panel, PanelBody } from "@wordpress/components";
import Typography from "@material-ui/core/Typography";
import MosaicFacet from "./MosaicFacet.js";
import MosaicPlaceholder from "./MosaicPlaceholder.js";
import { PlainText } from "@wordpress/editor";
import apiFetch from "@wordpress/api-fetch";

export default class MosaicNewsBlock extends SmartfireComponent {
  static title = "Mosaïque d'actualités";

  static smartProps = {
    articles: smartProps.any.withDefault([
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ]),
    phone: smartProps.string.withDefault(""),
    title: smartProps.string.withDefault(""),
    background: smartProps.string.withDefault(""),
  };

  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      articles: [],
      loading: true,
    };
  }

  componentWillMount() {
    if (this.isEditing) {
      apiFetch({ path: "/wp/v2/get_mosaic_pages" }).then((posts) => {
        const articles = posts.map((p) => ({
          id: p.ID,
          title: p.post_title,
          description: p.shortDescription,
          image: p.image,
          url: p.url,
          post: p,
        }));
        this.setState({ posts: articles, articles: articles });
      });
    } else {
      apiFetch({
        path: `/wp/v2/get_mosaic_pages?in=${this.props.articles.join(",")}`,
      }).then((posts) => {
        const articles = posts.map((p) => ({
          id: p.ID,
          title: p.post_title,
          description: p.shortDescription,
          image: p.image,
          url: p.url,
          post: p,
        }));
        this.setState({
          articles,
          loading: false,
          currentArticle: articles[0],
        });
      });
    }
  }

  render() {
    if (this.isEditing) {
      return this.renderEdit();
    }
    if (this.state.loading) return <div />;

    return (
      <div className="mosaic-news-block">
        <div className="content-container">
          {this.props.title !== "" && (
            <div class="title-col">
              <h3 class="title-block">{this.props.title}</h3>
            </div>
          )}
          <Grid container spacing={24}>
            {this.article(this.props.articles[0]) &&
              !this.article(this.props.articles[1]) && (
                <Grid item xs={12}>
                  <MosaicFacet
                    title={this.article(this.props.articles[0]).title}
                    description={
                      this.article(this.props.articles[0]).description
                    }
                    image={this.article(this.props.articles[0]).image}
                    url={this.article(this.props.articles[0]).url}
                    height="row1-full"
                  />
                </Grid>
              )}
            {this.article(this.props.articles[0]) &&
              this.article(this.props.articles[1]) && (
                <Grid item xs={12} sm={7} lg={8}>
                  <MosaicFacet
                    title={this.article(this.props.articles[0]).title}
                    description={
                      this.article(this.props.articles[0]).description
                    }
                    image={this.article(this.props.articles[0]).image}
                    url={this.article(this.props.articles[0]).url}
                    height="row1-full"
                  />
                </Grid>
              )}
            {this.article(this.props.articles[1]) && (
              <Grid item xs={12} sm={5} lg={4}>
                <MosaicFacet
                  title={this.article(this.props.articles[1]).title}
                  description={this.article(this.props.articles[1]).description}
                  image={this.article(this.props.articles[1]).image}
                  url={this.article(this.props.articles[1]).url}
                  height="row1-full"
                />
              </Grid>
            )}

            {this.article(this.props.articles[2]) &&
              !this.article(this.props.articles[3]) && (
                <Grid item xs={12}>
                  <MosaicFacet
                    title={this.article(this.props.articles[2]).title}
                    description={
                      this.article(this.props.articles[2]).description
                    }
                    image={this.article(this.props.articles[2]).image}
                    url={this.article(this.props.articles[2]).url}
                    height="row2-full"
                  />
                </Grid>
              )}
            {this.article(this.props.articles[2]) &&
              this.article(this.props.articles[3]) && (
                <Grid item xs={12} md={5}>
                  <MosaicFacet
                    title={this.article(this.props.articles[2]).title}
                    description={
                      this.article(this.props.articles[2]).description
                    }
                    image={this.article(this.props.articles[2]).image}
                    url={this.article(this.props.articles[2]).url}
                    height="row2-full"
                  />
                </Grid>
              )}
            {this.article(this.props.articles[3]) &&
              !this.article(this.props.articles[4]) && (
                <Grid item xs={12} md={7}>
                  <MosaicFacet
                    title={this.article(this.props.articles[3]).title}
                    description={
                      this.article(this.props.articles[3]).description
                    }
                    image={this.article(this.props.articles[3]).image}
                    url={this.article(this.props.articles[3]).url}
                    height="row2-full"
                  />
                </Grid>
              )}
            {this.article(this.props.articles[3]) &&
              this.article(this.props.articles[4]) && (
                <Grid item xs={12} md={7}>
                  <Grid container spacing={24}>
                    <Grid item xs={12} md={12}>
                      <MosaicFacet
                        title={this.article(this.props.articles[3]).title}
                        description={
                          this.article(this.props.articles[3]).description
                        }
                        image={this.article(this.props.articles[3]).image}
                        url={this.article(this.props.articles[3]).url}
                        showGrid={true}
                        height="row2-half middle"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <MosaicFacet
                        title={this.article(this.props.articles[4]).title}
                        description={
                          this.article(this.props.articles[4]).description
                        }
                        image={this.article(this.props.articles[4]).image}
                        url={this.article(this.props.articles[4]).url}
                        height="row2-half"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}

            {this.article(this.props.articles[5]) && (
              <Grid item xs={12}>
                <MosaicFacet
                  title={this.article(this.props.articles[5]).title}
                  description={this.article(this.props.articles[5]).description}
                  image={this.article(this.props.articles[5]).image}
                  url={this.article(this.props.articles[5]).url}
                  showGrid={true}
                  height="row3-full middle"
                />
              </Grid>
            )}

            {this.article(this.props.articles[6]) && (
              <Grid item xs={12} md={7} xl={8}>
                <MosaicFacet
                  title={this.article(this.props.articles[6]).title}
                  description={this.article(this.props.articles[6]).description}
                  image={this.article(this.props.articles[6]).image}
                  url={this.article(this.props.articles[6]).url}
                  height="row3-full middle"
                />
              </Grid>
            )}

            {this.article(this.props.articles[6]) && (
              <Grid item xs={12} md={5} xl={4}>
                <MosaicPlaceholder phone={this.props.phone} />
              </Grid>
            )}
          </Grid>
        </div>
        {this.props.background !== "" && (
          <div
            class="block-background"
            style={{ backgroundColor: this.props.background }}
          ></div>
        )}
      </div>
    );
  }

  article(id) {
    if (id === null) return null;
    const article = this.state.articles.filter((p) => p.id === id)[0] || null;
    if (article === null) console.error("Article " + id + " can not be found");
    return article;
  }

  renderEdit() {
    return (
      <Panel>
        <PanelBody>
          <Typography variant="subtitle1">Articles à afficher</Typography>
          {this.props.articles.map((value, i) => (
            <FormControl style={{ width: "100%", minHeight: "1.75em" }} key={i}>
              <InputLabel htmlFor="select-multiple-chip">
                Article {i + 1}
              </InputLabel>
              <Select
                value={this.props.articles[i] || []}
                onChange={(e) => {
                  let newState = { ...this.props };
                  newState.articles[i] = e.target.value;
                  this.setAttributes({ articles: [...newState.articles] });
                }}
                input={<Input id="select-multiple-chip" />}
                renderValue={(selected) => (
                  <Chip
                    key={selected}
                    label={
                      this.article(selected)
                        ? this.article(selected).title
                        : "Loading..."
                    }
                  />
                )}
              >
                {this.state.posts.map((p) => (
                  <MenuItem key={p.id} value={p.id}>
                    {p.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ))}
          <FormControl style={{ width: "100%", minHeight: "1.75em" }}>
            <br />
            <PlainText
              onChange={(content) => this.setAttributes({ phone: content })}
              value={this.props.phone}
              placeholder="Numéro de téléphone devis"
              className="heading title"
            />
          </FormControl>
          <FormControl style={{ width: "100%", minHeight: "1.75em" }}>
            <br />
            <PlainText
              onChange={(content) => this.setAttributes({ title: content })}
              value={this.props.title}
              placeholder="Titre du bloc (facultatif)"
              className="heading title"
            />
          </FormControl>
          <FormControl style={{ width: "100%", minHeight: "1.75em" }}>
            <br />
            <PlainText
              onChange={(content) =>
                this.setAttributes({ background: content })
              }
              value={this.props.background}
              placeholder="Couleur de fond (hexa)"
              className="heading title"
            />
          </FormControl>
        </PanelBody>
      </Panel>
    );
  }
}
